import React, { createContext, useContext } from 'react';
import { createLocalStorageStore } from '@client/helpers/local-storage.helpers';

export type ProjectListView = 'List' | 'Map';

const { useStore: useStoredView, set: setStoredView } =
  createLocalStorageStore<ProjectListView>('project_list_view', 'Map');
const ProjectListViewContext = createContext<{
  view: ProjectListView;
  setView: (view: ProjectListView) => void;
}>({ view: 'Map', setView: () => undefined });

export const useProjectListView = () => useContext(ProjectListViewContext);

export const ProjectListViewProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const view = useStoredView((value) => (value === 'List' ? 'List' : 'Map'));
  const setView = setStoredView;
  return (
    <ProjectListViewContext.Provider value={{ view, setView }}>
      {children}
    </ProjectListViewContext.Provider>
  );
};
